import { Uuid } from '@ftr/contracts/type/shared'
import { AccessLevel } from '@ftr/distribution-contracts'
import { LocalDate, LocalTime } from '@js-joda/core'

export interface IdNamePair {
  id: Uuid
  name: string
}

export interface CartTime {
  startTime: LocalTime
  endTime: LocalTime | null
}

export interface CartItemModel {
  id: Uuid
  sessionId: Uuid
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: string
  startTime: string
  endTime: string | null
  accessLevel: AccessLevel
  requestedTimes: { startTime: string; endTime: string | null }[]
}

export interface CartItem extends CartTime {
  id: Uuid
  sessionId: Uuid
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: LocalDate
  requestedTimes: CartTime[]
  accessLevel: AccessLevel
}

export interface CartGroup {
  key: string
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: LocalDate
  items: CartItem[]
}

export interface CartStateModel {
  courtSystem: IdNamePair | undefined
  cartItems: CartItemModel[]
}

export const CART_STATE_DEFAULT: CartStateModel = { courtSystem: undefined, cartItems: [] }
